import { cx } from '@linaria/core';
import { AsyncIndicator } from './_async-indicator.js';
import { wrapper, saveIndicator } from './integration.save-indicator.style.js';
import { jsx } from 'react/jsx-runtime';
import { useComponentEntry } from '../../api.component-entry/query.get.js';

function ComponentFrameworkSaveIndicator(props) {
  const hasSavedEntry = useComponentEntry(props.entryKey, {
    select: entry => !!entry?.envelope.objectID
  });
  const state = useComponentEntry(props.entryKey, {
    select: entry => entry?.state
  });
  const indicatorState = (() => {
    if (!hasSavedEntry.data) {
      return undefined;
    }
    return state.data?.result;
  })();
  return /*#__PURE__*/jsx("div", {
    className: cx(props.className, wrapper, !props.leftAlignedOnMobile && "centerOnMobile"),
    "data-left-aligned-on-mobile": props.leftAlignedOnMobile,
    children: /*#__PURE__*/jsx(AsyncIndicator, {
      className: saveIndicator,
      isLoading: state.data?.isMutating ?? true,
      state: indicatorState
    })
  });
}

export { ComponentFrameworkSaveIndicator };
//# sourceMappingURL=integration.save-indicator.js.map
